import { render, staticRenderFns } from "./sendAdsOwn.vue?vue&type=template&id=9632acd2&scoped=true"
import script from "./sendAdsOwn.vue?vue&type=script&lang=js"
export * from "./sendAdsOwn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9632acd2",
  null
  
)

export default component.exports